import Iconify from "@/components/ui/Iconify";
import Span from "@/components/ui/Span";
import { useState } from "react";

const CustomWarningPasswordInput = ({
    name,
    value,
    onChange,
    placeholder,
    type,
    className = "",
    iconClassName = "",
    showEmptyError = false,
    icon,
    warningIcon,
    emptyErrorMsg,
    passMainClass = ""
}) => {
    const [passVisible, setPassVisible] = useState(false)
    return (
        <div className="w-full">
            <div className={`flex gap-4 items-center border rounded-full px-5 py-2 dark:bg-[#0E0E0E] ${showEmptyError && value === "" ? "border-red" : "dark:border-gray-600"} ${passMainClass}`}>
                {
                    icon &&
                    <Iconify icon={icon} className="!w-6 !h-6" />
                }
                <input
                    autoComplete="none"
                    name={name}
                    className={`px-4 py-1.5 dark:bg-inherit  border-l ${showEmptyError && value === "" ? "border-red" : "dark:border-gray-600"}  w-full placeholder:dark:text-neutral-500 transition duration-300 ${className} outline-none`}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    type={passVisible ? "text" : type}
                />
                <div className="absolute top-1/2 -translate-y-1/2 right-3">
                    {
                        showEmptyError && value === "" ?
                            <Iconify icon={warningIcon} className="!w-6 !h-6 !text-red" />
                            :
                            <Iconify onClick={() => setPassVisible(!passVisible)} icon={`${passVisible ? "stash:eye-opened-light" : "mingcute:eye-close-line"}`} className={`!w-6 !h-6 ${iconClassName}`} />
                    }
                </div>

            </div>
            <Span className={`!text-red px-1 ${(showEmptyError && value === "") ? "block" : "hidden"}`}>{emptyErrorMsg}</Span>
        </div>
    );
};

export default CustomWarningPasswordInput;
